import {
  collection,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { db } from '@/shared/config/firebase';

const BALANCES_COLLECTION = 'organization_balances';
// DEPRECATED: L'historique est maintenant stocké directement dans les documents de commande (order.debtHistory)
// Cette collection n'est plus utilisée pour les nouvelles écritures mais peut contenir des données historiques
const HISTORY_COLLECTION = 'organization_balance_history';

export type BalanceActorType = 'system' | 'user' | 'admin';

export interface BalanceActor {
  type: BalanceActorType;
  id?: string;
  email?: string;
  name?: string;
}

export interface BalanceHistoryEntry {
  id: string;
  organizationId: string;
  delta: number;
  balanceBefore: number;
  balanceAfter: number;
  reason?: string;
  orderId?: string;
  paymentIntentId?: string;
  chargeId?: string;
  refundId?: string;
  transferId?: string;
  productIndex?: number;
  metadata?: Record<string, any>;
  note?: string;
  actor?: BalanceActor;
  createdAt?: Date;
}

export class OrganizationBalanceClientRepository {
  /**
   * Récupère le solde actuel d'une organisation (0 si inexistant)
   */
  static async getCurrentBalance(organizationId: string): Promise<number | null> {
    const q = query(
      collection(db, BALANCES_COLLECTION),
      where('organizationId', '==', organizationId),
      limit(1)
    );
    const snap = await getDocs(q);
    if (snap.empty) return 0;
    const data = snap.docs[0].data() as any;
    return Number.isFinite(data.balance) ? data.balance : 0;
  }

  /**
   * Écoute en temps réel le solde
   */
  static listenToCurrentBalance(
    organizationId: string,
    cb: (balance: number | null) => void
  ): () => void {
    const q = query(
      collection(db, BALANCES_COLLECTION),
      where('organizationId', '==', organizationId),
      limit(1)
    );

    return onSnapshot(q, (snapshot) => {
      if (snapshot.empty) {
        cb(0);
        return;
      }
      const data = snapshot.docs[0].data() as any;
      cb(Number.isFinite(data.balance) ? data.balance : 0);
    });
  }

  /**
   * Écoute l'historique des mouvements (trié du plus récent au plus ancien)
   */
  static listenToHistory(
    organizationId: string,
    cb: (entries: BalanceHistoryEntry[]) => void,
    options?: { limitCount?: number }
  ): () => void {
    const q = query(
      collection(db, HISTORY_COLLECTION),
      where('organizationId', '==', organizationId),
      orderBy('createdAt', 'desc'),
      limit(options?.limitCount ?? 200)
    );

    return onSnapshot(q, (snapshot) => {
      const entries: BalanceHistoryEntry[] = snapshot.docs.map((doc) => {
        const raw = doc.data() as any;
        return {
          id: doc.id,
          organizationId: raw.organizationId,
          delta: raw.delta,
          balanceBefore: raw.balanceBefore,
          balanceAfter: raw.balanceAfter,
          reason: raw.reason,
          orderId: raw.orderId,
          paymentIntentId: raw.paymentIntentId,
          chargeId: raw.chargeId,
          refundId: raw.refundId,
          transferId: raw.transferId,
          productIndex: raw.productIndex,
          metadata: raw.metadata,
          note: raw.note,
          actor: raw.actor,
          createdAt: raw.createdAt?.toDate ? raw.createdAt.toDate() : raw.createdAt,
        };
      });

      cb(entries);
    });
  }
}

